import React from 'react'
import moment from 'moment'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import { Grid, Link, Typography } from '@mui/material'
import DetailsBox, { DetailRow } from '../../../../components/Cards/DetailsBox'
import CheckBox from '@mui/icons-material/CheckBox'

const TimeBlock = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
    <DetailRow label={label} value={value && moment(value).format('HH:mm')} />
  </Grid>
)
const DataPanel = ({ record }) => {
  return (
    <EPCRCard>
      <DetailsBox
        title="Incident Details"
        rows={[
          {
            label: 'Incident Date',
            value: moment(record?.createdAt).format('Do MMM YYYY HH:mm'),
          },
          {
            label: 'Linked Event',
            value: record?.event ? (
              <Link href={`/events/${record?.event?._id}`} target="_blank">
                {record?.event.title}
              </Link>
            ) : (
              'None'
            ),
          },
          { label: 'Competitor Number', value: record?.competitorNumber },
          { label: 'Type', value: record?.type },
          {
            label: 'No Neck Pain',
            value: record?.noNeckPain && <CheckBox color="success" />,
          },
          {
            label: 'Is Ambulatory',
            value: record?.ambulatory && <CheckBox color="success" />,
          },
          { label: 'Referral', value: record?.referral, fullWidth: true },
          {
            label: 'Advice Given',
            value: record?.adviceGiven,
            fullWidth: true,
          },
          { label: 'Notes', value: record?.notes, fullWidth: true },
        ]}
      />
    </EPCRCard>
  )
}

export default DataPanel
